import axios from "axios";
import { interceptor } from "./helper/middleware";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
});

interceptor(apiClient);

export default apiClient;
